import React from 'react';
import GoBackArrowSvg from '../../assets/icons/go-back-arrow.svg';

interface GoBackArrowIconProps {
  size?: number;
  className?: string;
}

const GoBackArrowIcon: React.FC<GoBackArrowIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={GoBackArrowSvg} 
      alt="Go Back Arrow Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default GoBackArrowIcon;
